import { createClient } from '@supabase/supabase-js';

// Replace these with your actual Supabase project credentials
// You can find them in your Supabase project settings
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'YOUR_SUPABASE_URL';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'YOUR_SUPABASE_ANON_KEY';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Newsletter subscription types
export interface NewsletterSubscriber {
  id?: string;
  email: string;
  source: string;
  subscribed_at?: string;
  status?: 'active' | 'unsubscribed';
  metadata?: {
    ip_address?: string;
    user_agent?: string;
    referrer?: string;
  };
}

// Newsletter signup function
export async function subscribeToNewsletter(email: string, source: string = 'widget') {
  try {
    // Check if email already exists
    const { data: existingSubscriber } = await supabase
      .from('newsletter_subscribers')
      .select('email, status')
      .eq('email', email)
      .single();

    if (existingSubscriber) {
      if (existingSubscriber.status === 'active') {
        return { 
          success: false, 
          message: 'You are already subscribed to our newsletter!' 
        };
      } else {
        // Reactivate subscription
        const { error } = await supabase
          .from('newsletter_subscribers')
          .update({ 
            status: 'active',
            subscribed_at: new Date().toISOString()
          })
          .eq('email', email);

        if (error) throw error;
        
        return { 
          success: true, 
          message: 'Welcome back! Your subscription has been reactivated.' 
        };
      }
    }

    // Add new subscriber
    const { error } = await supabase
      .from('newsletter_subscribers')
      .insert([
        {
          email,
          source,
          status: 'active',
          subscribed_at: new Date().toISOString(),
          metadata: {
            user_agent: navigator.userAgent,
            referrer: document.referrer || 'direct'
          }
        }
      ]);

    if (error) throw error;

    return { 
      success: true, 
      message: 'Thank you for subscribing! We\'ll notify you when OneVoice launches.' 
    };
  } catch (error) {
    console.error('Newsletter subscription error:', error);
    return { 
      success: false, 
      message: 'Something went wrong. Please try again later.' 
    };
  }
}

// Unsubscribe function
export async function unsubscribeFromNewsletter(email: string) {
  try {
    const { error } = await supabase
      .from('newsletter_subscribers')
      .update({ status: 'unsubscribed' })
      .eq('email', email);

    if (error) throw error;

    return { 
      success: true, 
      message: 'You have been unsubscribed from our newsletter.' 
    };
  } catch (error) {
    console.error('Newsletter unsubscribe error:', error);
    return { 
      success: false, 
      message: 'Something went wrong. Please try again later.' 
    };
  }
}